module.exports = __webpack_public_path__ + "static/hero-dummy-5afacd714c7262e1f2b9a570302c3e19.png";